import type { Coord } from "@dailywars/core/engine";
import { useCallback, type RefObject } from "react";

import { suppressGhostInteractionAtPoint } from "#/components/game/suppressGhostInteractionAfterDismiss";
import { getTileFromPointer } from "#/game/canvasInput";

import type { BoardTouchTap } from "./boardTouchTapTracking";

export function useBoardTouchTapHandler({
  canvasRef,
  boardWidth,
  boardHeight,
  onTileHover,
  onTileSelect,
}: {
  canvasRef: RefObject<HTMLCanvasElement | null>;
  boardWidth: number;
  boardHeight: number;
  onTileHover: (tile: Coord | null) => void;
  onTileSelect: (tile: Coord) => void;
}): (tap: BoardTouchTap) => void {
  return useCallback(
    ({ clientX, clientY }: BoardTouchTap) => {
      const canvas = canvasRef.current;
      if (!canvas) return;
      const coord = getTileFromPointer({
        canvas,
        clientX,
        clientY,
        boardWidth,
        boardHeight,
      });
      if (!coord || coord.x < 0 || coord.y < 0 || coord.x >= boardWidth || coord.y >= boardHeight) {
        return;
      }
      suppressGhostInteractionAtPoint({ clientX, clientY });
      onTileHover(coord);
      onTileSelect(coord);
    },
    [boardHeight, boardWidth, canvasRef, onTileHover, onTileSelect],
  );
}
